import React from 'react';
import { connect } from 'react-redux';
import { Box, Card, CardBody, Flex, Text, Container, Stack, Heading, Button, Table, Tbody, Image, Center } from '@chakra-ui/react';
import { ReduxState } from '../../store/state';
import { User } from '../../store/user/types';
import LoadingPage from '../../pages/loading/LoadingPage';
import MiniOrderRow from '../page/MiniOrderRow';
import { formatCurrency } from '../global/data/formatCurrencyHelper';
import { MdPayment } from 'react-icons/md';
import { SubmittedOrder } from '../../store/cart/types';

interface PostCheckoutProps {
  user: User | null;
  submittedOrders: SubmittedOrder[];
  isSubmitting: boolean;
}

const PostCheckout: React.FC<PostCheckoutProps> = ({ 
  user, submittedOrders, isSubmitting
}) => {

  // const renderPayButton = () => {
  //   return selectedOrderTransactions.map(transaction => {
  //     const url = transaction.data?.url;
  //     const isPaid = transaction.status === 'completed'; 
  //     if (transaction.method === 'card online fygaro') {
  //       return (
  //         <div key={transaction._id}>
  //         <a href={url} target="_blank" rel="noreferrer">
  //           <Button leftIcon={<MdPayment />} colorScheme='green' borderRadius={'full'} size={'xl'} pl={10} pr={10} pt={6} pb={6} fontSize={'xl'} isDisabled={isPaid}>
  //             Pay {formatCurrency(transaction.currency, transaction.amount)} Now
  //           </Button>
  //         </a> 
  //         <Flex flexDirection={'row'} justify={'space-around'} align={'center'} mt={2}>
  //           <Image
  //             src="/assets/images/visa-logo.png"
  //             alt="Visa Logo"
  //             h="32px"
  //           />
  //           <Image
  //             src="/assets/images/mastercard-logo.png"
  //             alt="MasterCard Logo"
  //             h="40px"
  //           />
  //         </Flex>
  //         {isPaid ?
  //         <Text as={'span'} color={'#5F5F5F'} pl={10} pr={10}>
  //           We received this payment.
  //         </Text>
  //         :
  //         <Text as={'span'} color={'#5F5F5F'} pl={10} pr={10}>
  //           Pressing this button will take you to our payment partner's site to securely submit payment.
  //         </Text>
  //         } 
  //         </div>        
  //       );
  //     } else {
  //       return null;
  //     }  
  //   })
  // }

  if (isSubmitting) {
    return (
      <Container maxW={'2xl'} pt={10}>
      <Card pt={20} style={{ borderRadius: 25 }} boxShadow="0 4px 16px rgba(0, 0, 0, 0.2)">
        <CardBody>
          <Stack
            as={Box}
            textAlign={'center'}
            spacing={{ base: 8, md: 14 }}
            py={{ base: 10, md: 16 }}>
            <LoadingPage loadingText='Placing your orders...' />
            <Table>
              <Tbody>
                {submittedOrders.map(submittedOrder => {
                  return (
                    <Box pb={2}>
                      <MiniOrderRow order={submittedOrder.confirmation} />
                    </Box>
                  )
                })}
              </Tbody>
            </Table>
            {/* {renderPayButton()} */}
            <Text color={'gray.900'}>
              Showfa Express: Request. Deliver. Impress
            </Text>
          </Stack>
        </CardBody>
      </Card>
    </Container>
    )
  }

  return (
    <Container maxW={'2xl'} pt={10}>
      <Card pt={20} style={{ borderRadius: 25 }} boxShadow="0 4px 16px rgba(0, 0, 0, 0.2)">
        <CardBody>
          <Stack
            as={Box}
            textAlign={'center'}
            spacing={{ base: 8, md: 14 }}
            py={{ base: 10, md: 16 }}>
            <Heading
              fontWeight={600}
              fontSize={{ base: 'xl', sm: '2xl', md: '4xl' }}
              lineHeight={'110%'}
              color={'#F7941D'}>
              Thank You <br />
              <Text as={'span'} color={'black'}>
                { user?.firstName && user.firstName !== 'Customer' ? `${user.firstName} ${user.lastName}!` : null}
              </Text>
            </Heading>
            <Box mx="auto">
            <Table style={{ margin: 'auto' }}>
              <Tbody>
                {submittedOrders.map(submittedOrder => {
                  return (
                    <Box pb={2} textAlign={'center'}>
                      <MiniOrderRow order={submittedOrder.confirmation} hideAmount={true}/>
                    </Box>
                  )
                })}
              </Tbody>
            </Table>
            </Box>
            {/* {renderPayButton()} */}
            <Text color={'gray.900'}>
              Showfa Express: Request. Deliver. Impress
            </Text>
          </Stack>
        </CardBody>
      </Card>
    </Container>
)
};

const mapStateToProps = (state: ReduxState) => {
  const { user } = state.user;
  const { submittedOrders, isSubmitting } = state.cart;
  return { user, submittedOrders, isSubmitting };
};

export default connect(mapStateToProps, {
})(PostCheckout);
